/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_UnlimitedInputs */

const en_pricing_compare_unlimited = /** @type {(inputs: Pricing_Compare_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited`)
};

const de_pricing_compare_unlimited = /** @type {(inputs: Pricing_Compare_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbegrenzt`)
};

const fr_pricing_compare_unlimited = /** @type {(inputs: Pricing_Compare_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illimité`)
};

const es_pricing_compare_unlimited = /** @type {(inputs: Pricing_Compare_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilimitado`)
};

const it_pricing_compare_unlimited = /** @type {(inputs: Pricing_Compare_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illimitato`)
};

const nl_pricing_compare_unlimited = /** @type {(inputs: Pricing_Compare_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onbeperkt`)
};

const pl_pricing_compare_unlimited = /** @type {(inputs: Pricing_Compare_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez limitu`)
};

const fi_pricing_compare_unlimited = /** @type {(inputs: Pricing_Compare_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rajaton`)
};

const da_pricing_compare_unlimited = /** @type {(inputs: Pricing_Compare_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubegrænset`)
};

const sv_pricing_compare_unlimited = /** @type {(inputs: Pricing_Compare_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obegränsad`)
};

/**
* | output |
* | --- |
* | "Unlimited" |
*
* @param {Pricing_Compare_UnlimitedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_unlimited = /** @type {((inputs?: Pricing_Compare_UnlimitedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_UnlimitedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_compare_unlimited(inputs)
	if (locale === "fr") return fr_pricing_compare_unlimited(inputs)
	if (locale === "es") return es_pricing_compare_unlimited(inputs)
	if (locale === "it") return it_pricing_compare_unlimited(inputs)
	if (locale === "nl") return nl_pricing_compare_unlimited(inputs)
	if (locale === "pl") return pl_pricing_compare_unlimited(inputs)
	if (locale === "fi") return fi_pricing_compare_unlimited(inputs)
	if (locale === "da") return da_pricing_compare_unlimited(inputs)
	if (locale === "sv") return sv_pricing_compare_unlimited(inputs)
	return en_pricing_compare_unlimited(inputs)
});